import FeatureSnippetAction from './FeatureSnippetAction';

export default FeatureSnippetAction;
export { FeatureSnippetAction };
